import axios, { AxiosPromise } from 'axios';

export const pristupSMSGet = (token: string | null, tokenURL: string): AxiosPromise => {
    return axios({
        method: 'GET',
        url: 'Akcionar/Pristup/SMS',
        params: {
            initcode: tokenURL
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};

export const pristupSMSPost = (kod: string): AxiosPromise => {
    return axios({
        method: 'POST',
        url: 'Akcionar/Pristup/SMS',
        data: {
            kod
        }
    });
};
